import React, { useEffect } from "react";

import { Form, Input } from "antd";

/**
 * modalShell: 부모에서 import한 LdasModal을 넘겨서,
 * 서브모듈 import/HMR 이슈로 LdasModal이 undefined 되는 경우를 방지
 */
const LdasLotAddModal = ({
  modalShell: ModalShell,
  visible,
  onCancel,
  onAdd,
}) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (!visible) return;
    form.resetFields();
  }, [visible, form]);

  const handleCancel = () => {
    form.resetFields();
    onCancel();
  };

  const handleSubmit = () => {
    form
      .validateFields()
      .then(({ lotName }) => {
        const trimmed = lotName.trim();
        onAdd(trimmed);
        form.resetFields();
      })
      .catch(() => {});
  };

  return (
    <ModalShell
      title="로트번호 추가"
      visible={visible}
      onCancel={handleCancel}
      onOk={handleSubmit}
      okText="추가"
      destroyOnClose
    >
      <Form form={form} layout="vertical">
        <Form.Item
          name="lotName"
          label="로트번호"
          style={{ marginBottom: 0 }}
          rules={[
            { required: true, message: "로트번호를 입력해 주세요" },
            {
              validator: (_, value) => {
                if (value && !String(value).trim()) {
                  return Promise.reject(new Error("로트번호를 입력해 주세요"));
                }
                return Promise.resolve();
              },
            },
          ]}
        >
          <Input placeholder="예: SV2024-042" autoComplete="off" />
        </Form.Item>
      </Form>
    </ModalShell>
  );
};

export default LdasLotAddModal;
